const styles = (theme) => ({
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: '600',
    padding: `10px 32px`,
    fontSize: theme.headerTextFontSize
  },
  formContainer: {
    padding: '20px 24px 0px 20px'
  },
  circularProgress: {
    color: theme.white
  },
  actionButton: {
    textTransform: 'none',
    minWidth: 120,
    '&$actionButtonDisabled': {
      cursor: 'not-allowed',
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8
    },
    '&$actionOutlineDisabled': {
      borderColor: theme.iconColor,
      color: theme.iconColor
    }
  },
  actionButtonDisabled: {},
  actionOutlineDisabled: {},
  actionContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    paddingTop: '30px',
  },
  errorMessageVisible: {
    color: theme.palette.error.main,
    fontSize: theme.textFontSize,
    marginTop: '8px',
    paddingLeft: '22px',
    marginBottom: '2px'
  }
});

export default styles;
